'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagPtAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 0C9.33333 4.31785e-05 18.6667 4.14252e-06 28 4.14252e-06C28 6.66667 28 13.3333 28 20C18.6667 20 9.33334 20 4.26918e-06 20L0 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 0L28 4.14252e-06V20H4.26918e-06L0 0Z", fill: "#FF2936" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.26918e-06 20H10.6667V4.14252e-06L0 0L4.26918e-06 20Z",
          fill: "#128415"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.6667 10C14.6667 12.2091 12.8758 14 10.6667 14C8.45753 14 6.66667 12.2091 6.66667 10C6.66667 7.79087 8.45753 6 10.6667 6C12.8758 6 14.6667 7.79087 14.6667 10ZM13.3333 10C13.3333 11.4728 12.1394 12.6667 10.6667 12.6667C9.19391 12.6667 8 11.4728 8 10C8 8.52725 9.19391 7.33334 10.6667 7.33334C12.1394 7.33334 13.3333 8.52725 13.3333 10Z",
          fill: "#FAF94F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.3335 8.33334C9.3335 8.14924 9.48274 8.00001 9.66683 8.00001H11.6668C11.8509 8.00001 12.0002 8.14924 12.0002 8.33334V10.6667C12.0002 11.4031 11.4032 12 10.6668 12C9.93045 12 9.3335 11.4031 9.3335 10.6667V8.33334Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.6667 10.6667C11.0349 10.6667 11.3333 9.70153 11.3333 9.33334C11.3333 8.96515 11.0349 8.66667 10.6667 8.66667C10.2985 8.66667 10 8.96515 10 9.33334C10 9.70153 10.2985 10.6667 10.6667 10.6667Z",
          fill: "#1D50B5"
        }
      )
    ]
  }
);
const VpFlagPtAsset = forwardRef(FlagPtAsset);

export { VpFlagPtAsset as default };
